// StatusBadge — Badge de estado dirigido por un mapa `value → { label, variant }`. El mismo
// componente sirve para negocio / usuario / plan / financiera / producto: cada pantalla pasa su
// propio `config` (los enums difieren por entidad). Reproduce los estados literales de los mocks M6
// (ACTIVO/INACTIVO/SUSPENDIDO, ACTIVA, PROPIA/EXTERNA…), delegando el color en el Badge del kit.
import { Badge } from '@/kit';

export interface StatusConfig {
    label: string;
    /** Variante del Badge del kit: success | warning | info | destructive | secondary | outline… */
    variant?: string;
}

export interface StatusBadgeProps {
    value: string;
    /**
     * Mapa estado → { label, variant }. `Partial` a propósito: en runtime `value` puede no estar en
     * el mapa (estado inesperado del backend) → el índice es `StatusConfig | undefined` y cae al
     * `fallbackLabel`. Un `Record<string, StatusConfig>` del caller es asignable sin fricción.
     */
    config: Partial<Record<string, StatusConfig>>;
    /** Texto si `value` no está en `config` (default: el value crudo). */
    fallbackLabel?: string;
    className?: string;
}

export function StatusBadge({ value, config, fallbackLabel, className }: StatusBadgeProps) {
    const entry = config[value];
    return (
        <Badge variant={entry?.variant ?? 'default'} className={className}>
            {entry?.label ?? fallbackLabel ?? value}
        </Badge>
    );
}
